export const POSITION_BANNER = {
    TOP: '66273673334e11ed867dfa163e89e3c8', // Top Classic
    BOTTOM: '6be075bf334e11ed867dfa163e89e3c8', //Bottom Classic
    TOP_CENTER: '6f11bc44334e11ed867dfa163e89e3c8', //Top Center
    BOTTOM_CENTER: '74283050334e11ed867dfa163e89e3c8', //Bottom Center
    BOTTOM_FULL: '7844b457334e11ed867dfa163e89e3c8', //Bottom Fully Expand
    TOP_FULL: '7c24122b334e11ed867dfa163e89e3c8', //Top Fully Expand
};
